import initialState from './initialState'

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'REQUEST_SIGN_ON_OFF_DATA':
      return Object.assign({}, state, {
        loading: action.loading
      })
    case 'RECEIVE_ACTIVE_DATA':
      return Object.assign({}, state, {
        activeData: action.payload.activeData
      })
    case 'RECEIVE_UPDATED_ACTIVE_DATA':
      const updatedActiveData = state.activeData.map(item => {
        if (action.payload.checkedLoads.includes(item._id)) {
          item.material = action.payload.material
        }
        return item
      })
      return Object.assign({}, state, {
        activeData: updatedActiveData
      })
    case 'RECEIVE_SIGN_ON_OFF_DATA':
      return Object.assign({}, state, {
        signOnOffData: action.payload.signOnOffData,
        projects: action.payload.projects,
        hauls: action.payload.hauls,
        drivers: action.payload.drivers,
        loading: action.loading,
        updatedDt: new Date()
      })
    case 'RECEIVE_SIGN_ON_OFF_DATA_ONLY':
      const updatedSignOnOff = state.signOnOffData
        .map(item => {
          if (action.payload.checkedSignOnOffs.includes(item._id)) {
            item.signOnTime = action.payload.values.signOnTime
            item.signOffTime = action.payload.values.signOffTime
          }
          return item
        })
        .sort((a, b) => {
          if (a.haulId < b.haulId) return -1
          if (a.haulId > b.haulId) return 0
          return 0
        })
      return Object.assign({}, state, {
        signOnOffData: updatedSignOnOff
      })
    case 'RECEIVE_FILTER_PROJECTS':
      return Object.assign({}, state, {
        filters: {
          projects: action.payload.projects,
          hauls: [...state.filters.hauls]
        }
      })
    case 'RECEIVE_FILTER_HAULS':
      return Object.assign({}, state, {
        filters: {
          projects: [...state.filters.projects],
          hauls: action.payload.hauls
        }
      })
    default:
      return state
  }
}

export default reducer
